module.exports = __webpack_public_path__ + "static/media/bg.129e0233.png";